import React, { useState, useEffect } from 'react'
import { Radio, Button, Typography, Space, Form, Input, Select } from 'antd'
import MinusCircleOutlined from '@ant-design/icons/MinusCircleOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import { db, timestamp } from '../../firebase'
import swal from '@sweetalert/with-react'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../redux'
import { Redirect } from 'react-router-dom'
import moment from 'moment'

const { Option } = Select
const { Title, Link } = Typography
const START_OF_VOTING = moment(new Date(2022, 5, 18))
const END_OF_VOTING = moment(new Date(2022, 6, 1))

const options = [
    { label: 'Apple', value: 'Apple' },
    { label: 'Pear', value: 'Pear' },
    { label: 'Orange', value: 'Orange' },
];

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 20, offset: 4 },
    },
};

function Voting() {
    const [value3, setValue3] = useState(null)
    const auth = useSelector(state => state.auth)
    const dispatch = useDispatch()

    const onChange3 = e => {
        setValue3(e.target.value)
    }

    const submit = (values) => {
        console.log(values)
        const currentDate = moment(new Date(2022, 5, 19))
        if(currentDate.isBefore(START_OF_VOTING)) return swal("Oops!", "Voting period starts on 18 May 2022.", "warning")
        if(currentDate.isAfter(END_OF_VOTING)) return swal('Oops!', "Voting period has ended.", "warning")


        return swal({
            icon: "info",
            title: "Summary of vote",
            content: (
                <div>
                    <ol>
                        <li>{values.vote1}</li>
                        <li>
                            {values.vote2}
                            {typeof values.nominees === "undefined"
                                ? <>{values.nominees = [values.vote2]}</>
                                : <ol type="A">
                                    {values.nominees.map(nominee => (<li>{nominee}</li>))}
                                </ol>
                            }
                        </li>
                        <li>{values.vote3}</li>
                        <li>{values.vote4}</li>
                        <li>{values.vote5}</li>
                        <li>{values.vote6}</li>
                        <li>{values.vote7}</li>
                    </ol>
                </div>
            ),
            buttons: {
                cancel: "Back",
                confirm: {
                    text: "Submit",
                    value: "submit"
                }
            }
        }).then((val) => {
            if(val === "submit") {
                const vote = {
                    vote1: values.vote1,
                    vote2: values.vote2,
                    vote3: values.vote3,
                    vote4: values.vote4,
                    vote5: values.vote5,
                    vote6: values.vote6,
                    vote7: values.vote7,
                    nominees: values.nominees,
                    timestamp: timestamp.fromDate(new Date()),
                    fullname: auth.fullname,
                    noOfShares: auth.noOfShares ?? null
                }
                console.log(vote)
                const payload = { ...auth }
                payload.hasVoted = true

                dispatch(actions.signedIn(payload))
                db.collection('users').doc(auth.email).update({ "hasVoted": true })
                db.collection('votes').add(vote)

                swal("Thank you for casting your vote.", "The total votes casted, as well as the number of shares represented by the same, shall be announced during the 2022 Annual Stockholders’ Meeting of Citicore Energy REIT Corporation on 8 June 2022.", "success")
            }
        })
    }

    return (
        <div>
            {
                auth.isLoggedIn ? (
                    <div style={{maxWidth: '1000px', margin: 'auto'}}>
                        {
                            auth.hasVoted 
                                ? (<>
                                    <Title level={2}>Thank you for casting your vote. The total votes casted, as well as the number of shares represented by the same, shall be announced during the 2022 Annual Stockholders’ Meeting of Citicore Energy REIT Corporation on 8 June 2022.</Title>
                                    <Title level={2}>You may attend Citicore Energy REIT Corporation’s Annual Stockholders’ Meeting on 8 June 2022 at 10:00 A.M., through the following link: <Link href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_MTYyMjJhYmUtYTdlNS00OGM4LWJlZGEtNjYzOGQ0NmVlZTY1%40thread.v2/0?context=%7b%22Tid%22%3a%22036b84b7-26b8-441d-87c1-f3590d3f2ed1%22%2c%22Oid%22%3a%226defe8d8-9967-4c9d-82da-abbfa68da093%22%2c%22IsBroadcastMeeting%22%3atrue%7d&btype=a&role=a" target="_blank" underline>CREIT ASM 2022</Link></Title>
                                    </>
                                    ) 
                                : (
                                    <Form
                                        onFinish={submit}
                                    >
                                        <ol type="1">
                                            <li className="tabbed spacing">
                                                Approval of the Minutes of the Annual Stockholders’ Meeting held on May 25, 2021
                                                <br />
                                                <Form.Item
                                                    name="vote1"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                            <li className="tabbed spacing">
                                                Election of Directors<br/>
                                                <Form.Item
                                                    name="vote2"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group onChange={onChange3} value={value3}>
                                                        <Space direction="vertical">
                                                            <Radio value="Vote for all nominees">Vote for all nominees listed below: <br/><br/>Edgar B. Saavedra <br/>Oliver Y. Tan <br/>Manuel Louie B. Ferrer <br/>Jez G. Dela Cruz <br/>Leonilo G. Coronel (independent director) <br/>Pacita U. Juan (independent director) <br/>Jose M. Layug, Jr. (independent director)<br/>Elizabeth Anne C. Uychaco (independent director)</Radio>
                                                            <Radio value="Withhold authority for all nominees">Withhold authority for all nominee listed above</Radio>
                                                            <Radio value="Withhold authority to vote for the nominees listed below:">Withhold authority to vote for the nominees listed below</Radio>
                                                        </Space>
                                                    </Radio.Group>
                                                </Form.Item>
                                                {
                                                    value3 === "Withhold authority to vote for the nominees listed below:"
                                                        ?(<Form.Item 
                                                            label="Nominee/s" 
                                                            name="nominees" 
                                                            rules={[
                                                                {
                                                                    validator: async (_, nominees) => {
                                                                        if (!nominees || nominees.length < 1) {
                                                                            return Promise.reject(new Error('Select at least 1 nominee'));
                                                                        }
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <Select style={{ width: '25%' }} mode="multiple">
                                                                <Option value="Edgar B. Saavedra">Edgar B. Saavedra</Option>
                                                                <Option value="Manuel Louie B. Ferrer">Oliver Y. Tan</Option>
                                                                <Option value="Oliver Y. Tan">Manuel Louie B. Ferrer</Option>
                                                                <Option value="Ramon H. Diaz">Jez G. Dela Cruz</Option>
                                                                <Option value="Hilario G. Davide Jr.">Leonilo G. Coronel (independent director)</Option>
                                                                <Option value="Celso P. Vivas">Pacita U. Juan (independent director)</Option>
                                                                <Option value="Alfredo E. Pascual">Jose M. Layug, Jr. (independent director)</Option>
                                                                <Option value="Alfredo E. Pascual">Elizabeth Anne C. Uychaco (independent director)</Option>
                                                            </Select>
                                                        </Form.Item>)
                                                        : (<></>)
                                                }
                                            </li>
                                            <li className="tabbed spacing">
                                                Ratification of the 2021 Audited Financial Statements
                                                <br />
                                                <Form.Item
                                                    name="vote3"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                            <li className="tabbed spacing">
                                                Appointment of Isla Lipana &amp; Co. as external auditor
                                                <br />
                                                <Form.Item
                                                    name="vote4"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                            <li className="tabbed spacing">
                                                Ratification of all acts of Management and the Board of Directors
                                                <br />
                                                <Form.Item
                                                    name="vote5"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                            <li className="tabbed spacing">
                                                Approval of the Amendment of By-Laws changing the date of the annual stockholders’ meeting from the first Monday of April to June 8 of every year.
                                                <br />
                                                <Form.Item
                                                    name="vote6"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                            <li className="tabbed spacing">
                                                Approval of the issuance by the Company of fixed-rate bonds not exceeding thirty five percent (35%) of the value of its Deposited Property or up to the allowable leverage under the Real Estate Investment Trust (REIT) Act of 2009 (“REIT Law”) and its implementing rules and regulations (“REIT Law IRR”).
                                                <br />
                                                <Form.Item
                                                    name="vote7"
                                                    rules={[{ required: true, message: 'Please choose your vote' }]}
                                                >
                                                    <Radio.Group>
                                                        <Radio value="Yes">Yes</Radio>
                                                        <Radio value="No">No</Radio>
                                                        <Radio value="Abstain">Abstain</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </li>
                                        </ol>
                                        <Form.Item>
                                            <Button type='primary' htmlType="submit">Submit</Button>
                                        </Form.Item>
                                    </Form>
                                )
                        }
                    </div>
                ) : (<Redirect to="/" />)
            }
        </div>
    )
}

export default Voting
